import { SortingState } from '@tanstack/react-table';

interface SortQuery {
    sortBy?: string;
    sortByDesc?: string;
}

const sortQuery = (sorting: SortingState): SortQuery => {
    if (sorting.length === 0) {
        return {};
    }

    const sortKey = sorting[0].desc ? 'sortByDesc' : 'sortBy';

    return { [sortKey]: sorting[0].id };
};

export type { SortQuery };
export { sortQuery };
